import React, {useEffect, useState} from "react";
import {useGetSessionQuery} from "../api/session.ts";
import {isAcquiring, Session, SessionSimpleState, SessionStateMap} from "../types/sessionsstate.ts";
import {Routes} from "../utils/router.tsx";
import {useParams} from "react-router-dom";
import {SessionLoader} from "./SessionLoader.tsx";
import {NavigationPrompt} from "./NavigationPrompt.tsx";
import {useTranslation} from "react-i18next";
import {SelkiesDisplay} from "./SelkiesDisplay.tsx";

export const Acquisition: React.FC = () => {
    const {sessionId} = useParams<{sessionId: string}>();
    const [session, setSession] = useState<Session | undefined>();

    const [connectionError] = useState<boolean>(false);

    const {data: freshSession} = useGetSessionQuery({id: sessionId}, {pollingInterval: 5000, skip: connectionError});

    const {t} = useTranslation();

    useEffect(() => {
        document.body.classList.toggle("dark", true);
        return () => {
            document.body.classList.toggle("dark", false);
        };
    }, [location.pathname]);

    useEffect(() => {
        if (session?.state !== freshSession?.state) {
            setSession(freshSession);
        }
    }, [freshSession]);

    useEffect(() => {
        if (session && session.id) {
            if (SessionStateMap[session.state] === SessionSimpleState.COMPLETED ||
                SessionStateMap[session.state] === SessionSimpleState.FINALIZING ||
                SessionStateMap[session.state] === SessionSimpleState.FAILED ||
                SessionStateMap[session.state] === SessionSimpleState.ABORTED
            ) {
                Routes.goSessions();
            }
        }
    }, [session]);

    return <>
        {isAcquiring(session) ?
            <>
                <NavigationPrompt message={t("new.leave")} dark={true} todo={() => Routes.goSessions(true)}/>
                <SelkiesDisplay address={session?.frameUrl} />
            </> :
            (session ?
                <SessionLoader session={session}/> :
                null
            )
        }
    </>;

    // return connectionError ? (
    //     <KContainer>
    //
    //     </KContainer>
    // ) : (
    // );
}